<template>
    <div class="home_bottom">
    <a href="/" class="home_flex">
        <div>
            <img src="@/assets/img/bottom_01.png" />
        </div>
        <span>招聘公告</span>
    </a>

    <a href="/m/xby" class="home_flex">
        <div>
            <img src="@/assets/img/bottom_02.png" />
        </div>
        <span>考编工具</span>
    </a>

    <a href="/m/productcentre" class="home_flex">
        <div>
            <img src="@/assets/img/bottom_03.png" />
        </div>
        <span>选课中心</span>
    </a>
    <a :href="data_inof.phone != null ? 'tel:' + data_inof.phone : 'tel:16673138137'" class="home_flex">
        <div>
            <img src="@/assets/img/bottom_04.png" />
        </div>
        <span>{{  data_inof.phone != null ? data_inof.phone : '166-7313-8137' }}</span>
    </a>
    </div>
</template>

<script>
  export default {
    name: "home",
    data() {
      return {
        data_inof: {}
      };
    },
    props:{
    },
    created() {
      if(localStorage.getItem('subject') != null) {
          this.data_inof = JSON.parse(localStorage.getItem('data_inof'))
      }
    },
    methods:{
    },
    mounted() {
    
    },
    components: {
    },
  };
</script>

<style lang="less" scoped>
  .home_bottom {
    width: 7.5rem;
    height: 1.24rem;
    position: fixed;
    bottom: 0;
    background: #FFF;
    display: flex;
    left: 0;
    right: 0;
    box-shadow: 0rem -.1rem .2rem rgba(7, 0, 2, 0.06);
    margin: auto;
    justify-content: space-around;
    .home_flex {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: .20rem;
      &:last-child {
        margin-right: 0;
      }
      > div {
        width: .5rem;
        height: 0.44rem;
        display: flex;
        margin: 0 auto;
        margin-top: .1rem;
        > img {
            display: block;
            height: 100%;
        }
      }

      &:nth-child(2) {
        > div {
          height: 0.42rem;
          > img {
              height: 100%;
          }
        }
      }

      &:nth-child(4) {
        > div {
          height: 0.48rem;
          > img {
              height: 100%;
          }
        }
      }

      > span {
        display: block;
        text-align: center;
        margin-top: .16rem;
        font-size: 0.2rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #393939;
      }
    }
  }
</style>
